import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import LeadershipTimeline from '../components/Timeline';

const About = () => {
  return (
    <div className="about-page">

      {/* ── Page Banner ──────────────────────────────────────────────── */}
      <section className="page-banner"
        style={{
          backgroundImage: `url('/about-banner.png')`,
          backgroundPosition: 'center',

          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',


        }}>



        {/* img="Images/about-banner.png"> */}
        <div className="container">
          <div className="banner-content">
            <h1>About G.A.D.</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span> / </span>
              <span>About Us</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Who We Are ───────────────────────────────────────────────── */}
      <section className="about-intro">
        <div className="container">
          <div className="intro-grid">


            <div className="intro-image">
              <div className="intro-image-placeholder">
                <span> <img src="/logo.png" alt='about logo' className="about-logo-img" /> </span>
              </div>
            </div>


            <div className="intro-text">
              <span className="section-label">Who We Are</span>
              <h2 className="section-heading">Powering India With Quality Electrical Products</h2>
              <p className='intro-paragraph'>
                G.A.D. Electrical Industries is an ISO 9001:2015 certified manufacturer of high-precision electrical contact components based in New Delhi. We specialize in bimetal contact rivets, silver alloy contacts, and copper rivets for switchgear and electrical applications.
                With over 35 years of industry experience, our foundation is built on strong technical leadership and hands-on manufacturing expertise. Our background in production supervision and strict quality control ensures consistent performance and reliability.
                We focus on precision engineering, quality inspection, and timely delivery to OEMs. Our goal is to be a trusted long-term partner by providing durable, high-conductivity, and performance-driven electrical contact solutions.
              </p>
              <div className="intro-stats">
                <div className="intro-stat">
                  <span className="intro-stat-num">35+</span>
                  <span className="intro-stat-label">Years Experience</span>
                </div>
                <div className="intro-stat">
                  <span className="intro-stat-num">1000+</span>
                  <span className="intro-stat-label">Products</span>
                </div>
                <div className="intro-stat">
                  <span className="intro-stat-num">10K+</span>
                  <span className="intro-stat-label">Happy Clients</span>
                </div>
                <div className="intro-stat">
                  <span className="intro-stat-num">100+</span>
                  <span className="intro-stat-label">Dealer Partners</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Mission & Vision ─────────────────────────────────────────── */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card">
              <div className="mission-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To provide every Indian household and business with access to safe, high-quality,
                and affordable electrical products, backed by expert guidance and reliable after-sales support.
              </p>
            </div>
            <div className="mission-card">
              <div className="mission-icon">🔭</div>
              <h3>Our Vision</h3>
              <p>
                To be India's most trusted electrical products company known for integrity,
                quality, and innovation while contributing to a safer and more energy-efficient nation.
              </p>
            </div>
            <div className="mission-card">
              <div className="mission-icon">💎</div>
              <h3>Our Values</h3>
              <p>
                Quality without compromise. Transparency in every transaction. Respect for customers,
                partners, and the environment. These principles guide everything we do at gad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Our Journey ──────────────────────────────────────────────────────── */}



      <section className="journey-section">
        <div className="container">
          <span className="section-label center">Our Story</span>
          <h2 className="section-heading center">Our Journey</h2>
          <div>
            <LeadershipTimeline />

          </div>
        </div>
      </section>



      {/* ── Leadership Section ─────────────────────────────────────────────── */}
      <section className="leadership-section">
        <div className="container">

          <span className="section-label center">Leadership & Technical Expertise</span>
          <h2 className="section-heading center">
            Built on 35+ Years of Industry Experience
          </h2>

          <div className="leadership-grid">

            {/* LEFT SIDE – Founder */}
            <div className="leader-card founder">


              <div className="leader-content">
                <h3 className="leader-name">DOL RAJ SHARMA</h3>
                <span className="leader-role">Founder & Technical Head</span>

                <p className="leader-bio">
                  With over three decades of hands-on experience in electrical contact manufacturing,
                  he began his career in 1988 with one of the industry’s most reputed companies.
                  Promoted to Foreman in 1990, he independently managed production,
                  technical operations, and quality systems until 2014.
                </p>
                <br />

                <p className="leader-bio">
                  In 2014, he founded G.A.D Electrical Industries with a clear vision
                  to manufacture precision silver contact components with consistent
                  metallurgical control and uncompromised reliability.
                </p>
                <br />

                <ul className="leader-points">
                  <li>35+ Years Industry Experience</li>
                  <li>Expertise in AgSnO₂, AgCdO, AgNi Contacts</li>
                  <li>Production & Process Control Specialist</li>
                </ul>
              </div>
            </div>


            {/* RIGHT SIDE – Next Generation */}
            <div className="leader-card next-gen">


              <div className="leader-content">
                <h3 className="leader-name">SURAJ SHARMA</h3>
                <span className="leader-role">Operations & Business Development</span>

                <p className="leader-bio">
                  Leading the next phase of expansion, he focuses on scaling manufacturing capacity,
                  improving process efficiency, and strengthening OEM partnerships.
                </p>
                <br />

                <p className="leader-bio">
                  With a growth-driven approach, he integrates modern systems,
                  structured financial planning, and premium brand positioning
                  to elevate the company to national-level manufacturing standards.
                </p>
                <br />

                <ul className="leader-points">
                  <li>Manufacturing Scale Strategy</li>
                  <li>Production Optimization</li>
                  <li>OEM Relationship Development</li>
                </ul>
              </div>
            </div>

          </div>

          <div className="leadership-tagline">
            Combining traditional manufacturing expertise with modern growth vision.
          </div>

        </div>
      </section>



    </div>
  );
};

export default About;
